const dateFormat_0 = (dateString) => {


  // FORMATS DATE TO UTC
  // for this type of date: "Wed Dec 27 2023 19:00:00 GMT-0500 (Eastern Standard Time)"
// const date = new Date(dateString);
// const year = date.getFullYear();
// const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
// const day = String(date.getDate()).padStart(2, '0');
// const formattedDate = `${year}-${month}-${day}`;
// return formattedDate

// FORMATS DATE TO UTC TAKE 2 
if (!dateString) return '';
const d = new Date(dateString);
const year = d.getUTCFullYear();
const month = ('0' + (d.getUTCMonth() + 1)).slice(-2); // getMonth is 0-indexed
const day = ('0' + d.getUTCDate()).slice(-2);
return `${year}-${month}-${day}`;




  // const date = new Date(dateString);
  // console.log("DateString", dateString)
  // const options = { year: "numeric", month: "2-digit", day: "2-digit", timeZone: "UTC" };
  // const formattedDate = date
  //   .toLocaleDateString("en-US", options)
  //   .split('/')
  //   .reverse() // Reverse the order of month and day
  //   .join('-'); // Join with dashes
  //   console.log('FDATE', formattedDate)






}


const dateFormat_1 = (date) => {
     return new Date(date).toLocaleDateString("en-GB")
}


{/* 
     PROMPT
     Write me a JS function called dateFormat_2, that would take one argument, the argument will be a date. What I want you to return is the time difference between now and the date argument. If it has been less than a minute, return how many seconds is the time difference, if less than an hour, how many minutes and seconds, if less than a day, how many hours and minutes, if less than a week, how many days ago, if less than a month, how many days ago, if less than a year, how many months ago
*/}
// difference since Date
// function dateFormat_2(dateArg) {
//      const date = new Date(dateArg);
//      const now = new Date();
//      const timeDifferenceInSeconds = Math.floor((now - date) / 1000);
   
//      if (timeDifferenceInSeconds < 60) {
//        return `${timeDifferenceInSeconds} second${timeDifferenceInSeconds !== 1 ? 's' : ''} ago`;
//      } else if (timeDifferenceInSeconds < 3600) {
//        const minutes = Math.floor(timeDifferenceInSeconds / 60);
//        const seconds = timeDifferenceInSeconds % 60;
//        return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
//      } else if (timeDifferenceInSeconds < 86400) {
//        const hours = Math.floor(timeDifferenceInSeconds / 3600);
//        const minutes = Math.floor((timeDifferenceInSeconds % 3600) / 60);
//        return `${hours} hour${hours !== 1 ? 's' : ''} and ${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
//      } else if (timeDifferenceInSeconds < 604800) {
//        const days = Math.floor(timeDifferenceInSeconds / 86400);
//        return `${days} day${days !== 1 ? 's' : ''} ago`;
//      } else if (timeDifferenceInSeconds < 2592000) {
//        const weeks = Math.floor(timeDifferenceInSeconds / 604800);
//        return `${weeks} week${weeks !== 1 ? 's' : ''} ago`;
//      } else if (timeDifferenceInSeconds < 31536000) {
//        const months = Math.floor(timeDifferenceInSeconds / 2592000);
//        return `${months} month${months !== 1 ? 's' : ''} ago`;
//      } else {
//        const years = Math.floor(timeDifferenceInSeconds / 31536000);
//        return `${years} year${years !== 1 ? 's' : ''} ago`;
//      }
// }

// cld
function dateFormat_2(dateArg) {
  const date = new Date(dateArg);
  const now = new Date();
  const diff = Math.floor((now - date) / 1000);

  const plural = (n, word) => `${n} ${word}${n !== 1 ? 's' : ''}`;

  if (diff < 60) {
    return `${plural(diff, 'second')} ago`;
  } else if (diff < 3600) {
    return `${plural(Math.floor(diff / 60), 'minute')} ago`;
  } else if (diff < 86400) {
    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    return `${plural(hours, 'hour')} and ${plural(minutes, 'minute')} ago`;
  } else if (diff < 604800) {
    return `${plural(Math.floor(diff / 86400), 'day')} ago`;
  } else if (diff < 2592000) {
    return `${plural(Math.floor(diff / 604800), 'week')} ago`;
  }

  // Calendar-based months/years
  let totalMonths =
    (now.getFullYear() - date.getFullYear()) * 12 +
    (now.getMonth() - date.getMonth());
  if (now.getDate() < date.getDate()) totalMonths--;

  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  if (years === 0) {
    return `${plural(Math.max(totalMonths, 1), 'month')} ago`;
  }
  if (months === 0) {
    return `${plural(years, 'year')} ago`;
  }
  return `${plural(years, 'year')} and ${plural(months, 'month')} ago`;
}


// difference since date, if older than 1 year, full date
// function dateFormat_2(dateArg) {
//     const date = new Date(dateArg.replace(' ', 'T'));
//     const now = new Date();

//     const timeDifferenceInSeconds = Math.floor((now - date) / 1000);

//     if (timeDifferenceInSeconds < 0) {
//         return 'Just now';
//     } else if (timeDifferenceInSeconds < 60) {
//         return `${timeDifferenceInSeconds} second${timeDifferenceInSeconds !== 1 ? 's' : ''} ago`;
//     } else if (timeDifferenceInSeconds < 3600) {
//         const minutes = Math.floor(timeDifferenceInSeconds / 60);
//         return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
//     } else if (timeDifferenceInSeconds < 86400) {
//         const hours = Math.floor(timeDifferenceInSeconds / 3600);
//         const minutes = Math.floor((timeDifferenceInSeconds % 3600) / 60);
//         return `${hours} hour${hours !== 1 ? 's' : ''} and ${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
//     } else if (timeDifferenceInSeconds < 604800) {
//         const days = Math.floor(timeDifferenceInSeconds / 86400);
//         return `${days} day${days !== 1 ? 's' : ''} ago`;
//     } else if (timeDifferenceInSeconds < 2592000) {
//         const weeks = Math.floor(timeDifferenceInSeconds / 604800);
//         return `${weeks} week${weeks !== 1 ? 's' : ''} ago`;
//     } else if (timeDifferenceInSeconds < 31536000) {
//         const months = Math.floor(timeDifferenceInSeconds / 2592000);
//         return `${months} month${months !== 1 ? 's' : ''} ago`;
//     } else {
//         return date.toLocaleDateString('en-CA', {
//             year: 'numeric',
//             month: 'short',
//             day: 'numeric'
//         });
//     }
// }

// function dateFormat_3(dateString) {
//   console.log(dateString);
//   const options = { day: "numeric", month: "short", year: "numeric" };
//   const formattedDate = new Date(dateString).toLocaleDateString("en-US", options);
//   return formattedDate;
// }

function dateFormat_3(dateString) {
  // console.log('DSTRING', dateString)
  try {
    const options = { day: "numeric", month: "long", year: "numeric"};
    const formattedDate = new Date(dateString).toLocaleDateString("en-US", {...options, timeZone: "UTC"});
    return formattedDate;
  } catch (error) {
    console.error("Error parsing date:", error);
    return "Invalid Date";
  }
}

function dateFormat_4(dateString) {
  // console.log('DSTRING', dateString)
  try {
    const options = { day: "numeric", month: "long", year: "numeric", hour: "2-digit",
    minute: "2-digit",
    second: "2-digit", };
    const formattedDate = new Date(dateString).toLocaleDateString("en-US", {...options});
    return formattedDate;
  } catch (error) {
    console.error("Error parsing date:", error);
    return "Invalid Date";
  }
}


const isDateBeforeToday = (givenDate, today) => {
  // const today = new Date();
  // date = new Date(date); 
  // console.log("\n\n\n\nDATE", date.getTime(), today.getTime())

  // // Use the getTime method to compare the dates as timestamps
  // return date.getTime() < today.getTime();

    // Set the time of today's date to 00:00:00
    const todayStart = new Date(today);
    todayStart.setHours(0, 0, 0, 0);
  
    // Set the time of the given date to 23:59:59
    const givenDateEnd = new Date(givenDate);
    givenDateEnd.setHours(23, 59, 59, 999);
  
    // Compare the dates
    return givenDateEnd < todayStart;


}


export {dateFormat_0, dateFormat_1, dateFormat_2, dateFormat_3, dateFormat_4, isDateBeforeToday}